import '@angular/localize/init';
import 'zone.js';
import 'hammerjs';